import { Box, Divider } from "@mui/material";
import React, { useCallback } from "react";

import CustomPopover from "@convin/components/custom_components/Popover/CustomPopover";
import { Label } from "@convin/components/custom_components/Typography/Label";
import TrailingSvg from "@convin/components/svg/TrailingSvg";

import useGlobalFiltersStateContext from "../../../../../../hooks/useGlobalFiltersStateContext";
import { StyledFilterBox } from "../../../styles";
import useAuth from "@convin/hooks/useAuth";
import { getUserName } from "@convin/utils/helper/common.helper";
import PersonIcon from "@mui/icons-material/Person";
import FilterListButton from "./FilterListButton";

export default function AssignByFilter() {
    const { user } = useAuth();
    const { state, updateState } = useGlobalFiltersStateContext();

    const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLDivElement>): void => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = useCallback((): void => {
        setAnchorEl(null);
    }, []);

    const handleChange = (option: {
        id: number | null;
        value: string;
    }): void => {
        updateState({
            created_by: option.id ? [option.id] : [],
        });
        handleClose();
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    const options: Array<{
        id: number | null;
        value: string;
    }> = [
        ...(user
            ? [{ id: user.id, value: `Assigned by ${getUserName(user)}(Me)` }]
            : []),
        {
            id: null,
            value: "Assigned by all",
        },
    ];

    return (
        <>
            <StyledFilterBox onClick={handleClick} aria-describedby={id}>
                <PersonIcon
                    sx={{
                        fontSize: "18px",
                    }}
                />
                <Label
                    isEllipses
                    hasTooltip
                    colorType="white"
                    className="flex-1 font-semiBold"
                    variant="medium"
                >
                    {state.created_by.length > 0 ? getUserName(user) : "All"}
                </Label>

                <Box {...(open && { className: "rotate-180" })}>
                    <TrailingSvg />
                </Box>
            </StyledFilterBox>
            <CustomPopover
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                sx={{
                    "& .MuiPopover-paper": {
                        maxWidth: "300px",
                        width: "300px",
                    },
                }}
            >
                <Label colorType="666" variant="medium" sx={{ p: 1.5 }}>
                    Select Assigned By
                </Label>
                <Divider />
                <Box className="flex-1" sx={{ minWidth: 220 }}>
                    {options.map((option) => (
                        <FilterListButton
                            onClick={() => handleChange(option)}
                            key={option.id}
                        >
                            {option.value}
                        </FilterListButton>
                    ))}
                </Box>
            </CustomPopover>
        </>
    );
}
